import constants from '../constants.js';

const HotelSupplierModifiedOn = {
  displayName: 'Modified On',
  dataAt: 'ModifiedOn',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  disabled: true
};

const HotelSupplierModifiedBy = {
  displayName: 'Modified By',
  dataAt: 'ModifiedBy',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  disabled: true
};

const HotelSupplierCreatedOn = {
  displayName: 'Created On',
  dataAt: 'CreatedOn',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  disabled: true
};

const HotelSupplierCreatedBy = {
  displayName: 'Created By',
  dataAt: 'CreatedBy',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  disabled: true
};

const HotelSupplierLoyaltyPartnershipMembershipCodes = {
  displayName: 'Hotel Loyalty Partners',
  dataAt: 'LoyaltyPartnerMembershipCodes',
  displayAs: constants.DISPLAY_AS.TAG_INPUT
};

const HotelSupplierCode = {
  displayName: 'Hotel Membership Code',
  dataAt: 'MembershipCode',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const HotelSupplierName = {displayName: 'Name', dataAt: 'Name', displayAs: constants.DISPLAY_AS.TEXT_INPUT};

const HotelSupplierId = {
  displayName: 'Identifier',
  dataAt: 'Id',
  disabled: true,
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const HotelSuppliersAdminPanel = {
  dataAt: '',
  displayAs: constants.DISPLAY_AS.GROUP,
  tabName: 'Admin',
  children: [HotelSupplierCreatedBy, HotelSupplierCreatedOn, HotelSupplierModifiedBy, HotelSupplierModifiedOn]
};

const HotelSuppliersTabsInfoPanel = {
  dataAt: '',
  displayAs: constants.DISPLAY_AS.GROUP,
  tabName: 'Info',
  children: [HotelSupplierId, HotelSupplierName, HotelSupplierCode, HotelSupplierLoyaltyPartnershipMembershipCodes]
};

const HotelSuppliersMembershipCode = {
  displayName: 'Membership Code',
  dataAt: 'MembershipCode',
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const HotelSuppliersName = {displayName: 'Name', dataAt: 'Name', displayAs: constants.DISPLAY_AS.TEXT_INPUT};

const HotelSuppliersTabs = {
  dataAt: '',
  displayAs: constants.DISPLAY_AS.TABS,
  children: [HotelSuppliersTabsInfoPanel, HotelSuppliersAdminPanel]
};

const HotelSuppliersNameLabel = {dataAt: 'Name', displayAs: constants.DISPLAY_AS.SUB_HEADING, label: 'Name:'};

const HotelSupplierMembershipProgramsAddResource = {
  displayAs: constants.DISPLAY_AS.ADD_GRID_RESOURCE,
  displayName: 'Hotel Supplier',
  data: {Name: '', MembershipCode: ''},
  dataAt: '',
  children: [HotelSuppliersName, HotelSuppliersMembershipCode],
  endpoint: 'HotelSupplierMembershipPrograms'
};

const HotelSupplierMembershipProgramsResource = {
  displayName: 'Hotel Suppliers',
  displayAs: constants.DISPLAY_AS.RESOURCE,
  dataAt: '',
  children: [HotelSuppliersNameLabel, HotelSuppliersTabs],
  endpoint: 'HotelSupplierMembershipPrograms',
  routeParamId: 'hotelSupId'
};

const HotelSupplierMembershipProgramsList = {
  rootNode: true,
  displayName: 'Hotel Suppliers',
  endpoint: 'HotelSupplierMembershipPrograms',
  iconClass: 'fa-bed',
  displayAs: constants.DISPLAY_AS.GRID,
  gridItem: HotelSupplierMembershipProgramsResource,
  gridAdd: HotelSupplierMembershipProgramsAddResource,
  gridCols:
    [{name: 'Name', key: 'Name'},
      {name: 'Hotel Membership Code', key: 'MembershipCode'}]
};

export default {
  HotelSupplierMembershipProgramsList,
  HotelSupplierMembershipProgramsResource,
  HotelSupplierMembershipProgramsAddResource,
  HotelSuppliersNameLabel,
  HotelSuppliersTabs,
  HotelSuppliersName,
  HotelSuppliersMembershipCode,
  HotelSuppliersTabsInfoPanel,
  HotelSuppliersAdminPanel,
  HotelSupplierId,
  HotelSupplierName,
  HotelSupplierCode,
  HotelSupplierLoyaltyPartnershipMembershipCodes,
  HotelSupplierCreatedBy,
  HotelSupplierCreatedOn,
  HotelSupplierModifiedBy,
  HotelSupplierModifiedOn
}



// WEBPACK FOOTER //
// ./src/config/fields/hotelSuppliers.js